import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { selectDefectCodesToEdit, selectDefectCodeCategories } from "../../store/selectors/defectSelectors";
import { setToEditDefectCodes, updateItem } from "../../store/slices/defectSlice";
import { DefectCodeDialog } from "./DefectCodeDialog";
import { updateDefect } from "../../services/defectService";

export const EditDefectCodeDialog = () => {
    const dispatch = useAppDispatch();

    const toEdit = useAppSelector(selectDefectCodesToEdit);
    const defectCategories = useAppSelector(selectDefectCodeCategories);

    if (!toEdit) {
        return null;
    }

    const onSubmit = async (typeCode: string | null, codeAssignReason?: string | null, suggestedCodes?: string[]) => {
        const defect = {
            ...toEdit,
            typeCode,
            codeAssignReason,
            suggestedCodes: suggestedCodes ? JSON.stringify(suggestedCodes) : null
        };

        const updated = await updateDefect(defect);

        if (updated) {
            dispatch(updateItem(defect));
        }
    }

    const onHide = () => {
        dispatch(setToEditDefectCodes(undefined));
    };

    const category = toEdit?.typeCode ? defectCategories[toEdit.typeCode] : undefined;

    return <DefectCodeDialog 
        onSubmit={onSubmit} 
        visible={!!toEdit} 
        onHide={onHide} 
        currentTypeCode={toEdit?.typeCode}
        category={category}
        description={toEdit?.description || undefined}
    />;
}